import { Typography } from 'antd';
import styled from 'styled-components';

export const NotFoundWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ImgWrapper = styled.div`
  max-width: 7.5rem;
`;

export const Text = styled(Typography.Text)`
  font-weight: 700;
  font-size: 1.125rem;
`;
